import { render, staticRenderFns } from "./GraduatesSingleDocumentUpload.vue?vue&type=template&id=a44280a0&scoped=true&"
import script from "./GraduatesSingleDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./GraduatesSingleDocumentUpload.vue?vue&type=script&lang=js&"
import style0 from "./GraduatesSingleDocumentUpload.vue?vue&type=style&index=0&id=a44280a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44280a0",
  null
  
)

export default component.exports